var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoomColor15(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.23084C0 6.90504 0 6.57924 0 6.25012C0.00982747 6.21687 0.0262066 6.18695 0.0262066 6.15371C0.0687923 5.54866 0.203101 4.96355 0.41603 4.39839C1.60843 1.20358 4.88098 -0.578339 8.16991 0.169666C11.0166 0.817938 13.1819 3.4077 13.3261 6.35318C13.3916 7.65969 13.123 8.89307 12.4809 10.0367C12.363 10.2461 12.2352 10.4489 12.1009 10.675C12.1435 10.7116 12.1893 10.7415 12.2287 10.778C12.9788 11.536 13.7257 12.2973 14.4759 13.052C14.6986 13.2747 14.9148 13.5008 15 13.8166C15 13.9463 15 14.0726 15 14.2022C14.9803 14.2455 14.9574 14.2887 14.9443 14.3319C14.8624 14.558 14.7216 14.7375 14.5152 14.8538C14.0893 15.0999 13.6438 15.0234 13.2671 14.6411C12.4612 13.8266 11.6587 13.0121 10.8561 12.1976C10.82 12.161 10.8037 12.1045 10.7873 12.0746C10.4892 12.2707 10.2468 12.4436 9.98799 12.5932C8.62525 13.3911 7.15768 13.667 5.60821 13.4177C4.09806 13.175 2.82048 12.4702 1.77877 11.3366C0.904127 10.3824 0.347237 9.26541 0.114654 7.98549C0.0687923 7.73616 0.0360341 7.4835 0 7.23084ZM11.7569 6.74214C11.7471 3.89307 9.47696 1.58921 6.65648 1.59586C3.7803 1.60584 1.56257 3.97618 1.57895 6.77871C1.59533 9.59786 3.83271 11.9183 6.67613 11.9117C9.59489 11.905 11.77 9.47818 11.7569 6.74214Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.40471 2.39062C7.99021 2.49368 9.17278 3.23836 9.90984 4.67454C10.1162 5.0768 9.96553 5.53557 9.58554 5.74501C9.20554 5.95446 8.74693 5.82148 8.52745 5.42254C8.30797 5.02028 8.03935 4.66124 7.65608 4.40525C7.29246 4.16257 6.89281 4.01961 6.45385 3.99302C6.25075 3.97972 6.04437 3.97307 5.8642 3.86004C5.57265 3.67719 5.42852 3.3115 5.52024 2.97241C5.60869 2.63664 5.90351 2.40392 6.24747 2.39062C6.29988 2.39062 6.3523 2.39062 6.40471 2.39062Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -1.0002e-7,
    y1: 13.5,
    x2: 14,
    y2: 2.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D8CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675473,
    stopColor: "#56B9AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62CEA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 1.00061,
    y1: 11.5,
    x2: 11.0006,
    y2: 1.99998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D8CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62CEA3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomColor15);
export default __webpack_public_path__ + "static/media/zoom-color-15.fae05b72164e9f6888ff027ab5935a04.svg";
export { ForwardRef as ReactComponent };